import { useParams, Navigate } from "react-router-dom";
import { DomainPage } from "../components/DomainPage";
import { getDomainBySlug } from "../lib/domains";

export default function DomainDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const domain = slug ? getDomainBySlug(slug) : undefined;

  if (!domain) {
    return <Navigate to="/domains" replace />;
  }

  return <DomainPage domain={domain} />;
}
